import { getNodeAnimation } from "./../../../_shared/node-animation/get-node-animation.js";
const hasAnimatedNodes = (nodes) => nodes.some((node) => Boolean(getNodeAnimation(node)) || hasAnimatedNodes(node.nodes ?? []));
export {
  hasAnimatedNodes
};
//# sourceMappingURL=has-animated-nodes.js.map
